import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const customerListApi = createApi({
    reducerPath: 'customerListApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCustomersList: builder.query({
            query: ({ page, limit, search, vendor_id }) => {
                return {
                    url: `/get-users`,
                    method: 'GET',
                    params: {
                        page: page,
                        perPage: limit,
                        search: search ?? "",
                        vendor_id: vendor_id
                    },
                }
            },
            // providesTags: ['UserList'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),

        getChefsLists: builder.query({
            query: () => {
                return {
                    url: `/chef`,
                    method: 'GET',
                    params: {
                        perPage: "all",
                    },
                }
            },
            // providesTags: ['foodItem'],
            transformErrorResponse: (err) => transformResponseHandler(err),
        }),

        uploadImage: builder.mutation({
            query: (body) => ({
              url: '/upload',
              method: 'POST',
              body,
            }),
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error),
          }),
    }),
});

export const { useGetCustomersListQuery, useGetChefsListsQuery, useUploadImageMutation } = customerListApi;